
import { Outlet, Route } from 'react-router-dom'
import { RouteInfo, SiteMap } from 'interface/route'
import MainLayout from 'layouts/MainLayout'
import { MapViewRoot } from './mapView'
import { CalendarRoot } from './calendar'

export const mainLayoutRoute: RouteInfo = {
  key: 'Root',
  label: 'Root',
  path: '/',
  element: (
    <MainLayout>
      <Outlet />
    </MainLayout>
  ),
  children: {
    MapViewRoot,
    CalendarRoot
  },
}

export const renderRoute = (route: RouteInfo) => (
  <Route key={route.key} path={route.path} element={route.element}>
    {route?.children && renderSiteMap(route.children)}
  </Route>
)

export const renderSiteMap = (siteMap: SiteMap) => Object.values(siteMap).map(route => renderRoute(route))
